<template>
    <div>
        <sub-menu-call-center ativo="orcamento" v-if="!recepcao && !crm && !consultorio" />

        <marcacao :orcamento="true" ref="marc" />
    </div>
</template>

<script>
import _ from 'lodash';
import SubMenuCallCenter from './SubMenuCallCenter.vue';
import Marcacao from './Marcacao.vue';

export default {
    data() { 
        return { 
            estado: 1,
        }
    },

    props: ['id_orcamento'], 

    components: { 
        SubMenuCallCenter,
        Marcacao, 
    },

    computed: { 

        recepcao: function () { 
            return this.$route.name == 'rorcamento';
        },

        crm: function () { 
            return this.$route.name == 'crmorcamento';
        },

        consultorio: function () { 
            return this.$route.name == 'corcamento';
        },

    },

    mounted() { 
        if ( this.recepcao ) { 
            this.$store.commit("setBreadcrumb", [
                { name: "Recepção", path: "/recepcao" },
                { name: "Orçamento", path: "/recepcao/orcamento" }
            ]);
        } else if ( this.crm ) { 
            this.$store.commit("setBreadcrumb", [
                { name: "CRM", path: "/crm" },
                { name: "Orçamento", path: "/crm/orcamento" }
            ]);
        } else if ( this.consultorio ) { 
            this.$store.commit("setBreadcrumb", [
                { name: "Consultório", path: "/consultorio" },
                { name: '...', path: "/consultorio" },
                { name: "Orçamento", path: "/consultorio/orcamento" }
            ]);
        } else {
            this.$store.commit("setBreadcrumb", [
                { name: "Call Center", path: "/call-center" },
                { name: "Orçamento", path: "/call-center/orcamento" }
            ]);
        }

        let id_uo_ck = this.$util.getCookie('id_unidade_operacao');

        if ( id_uo_ck ) { 

            let unidade = this.$refs.marc.lista_unidades.find(und => und.id_unidade_operacao == id_uo_ck);

            if ( unidade ) { 
                this.$refs.marc.dados.unidade_operacao = unidade;    
            }

        }

        if ( this.consultorio ) { 

            let id_atendimento = this.$route.params.id_atendimento;

            this.$util.loadItem(this, { 
                service: 'orcamentos',
                func: 'dados_atend',
                parms: { 
                    id_atendimento: id_atendimento,
                    orcamento: true, 
                },
            })
            .then(res => { 

                console.log(res);

                if ( res.atendimento ) { 

                    this.atendimento = res.atendimento;

                    const plano = this.atendimento.plano;
                    const id_uo = this.atendimento.marcacao.id_unidade_operacao;
                    const nome  = this.atendimento.paciente.st_nome;

                    let unidade = this.$refs.marc.lista_unidades.find(und => und.id_unidade_operacao == id_uo);

                    if ( unidade ) { 
                        this.$refs.marc.dados.unidade_operacao = unidade;    
                    }

                    this.$refs.marc.$refs.orcamento.nome_paciente = nome;
                    this.$refs.marc.$refs.orcamento.paciente = this.atendimento.paciente;
                    this.$refs.marc.$refs.orcamento.id_atendimento = this.atendimento.id_atendimento;

                    if ( this.atendimento.medico && this.atendimento.medico.solicitante ) { 
                        this.$refs.marc.$refs.orcamento.info.medico_solicitante = this.atendimento.medico.solicitante;
                    }
                    
                    if ( this.atendimento.paciente ) { 
                        this.$refs.marc.$refs.orcamento.paciente.origem = { 
                            type: 'App\\azure\\atendimento', 
                            id: this.atendimento.id_atendimento
                        };
                    }
                    
                    this.$refs.marc.selecionarPlano(plano);

                    this.$store.commit("setBreadcrumb", [
                        { name: "Consultório", path: "/consultorio" },
                        { name: this.atendimento.paciente.st_nome, path: "/consultorio/res/" + this.atendimento.id_atendimento },
                        { name: "Orçamento", path: "/consultorio/orcamento" }
                    ]);

                }

            });

        }

        // Abertura do Orçamento 

        let id_orcamento = null;

        if ( this.$route.params && this.$route.params.id_orcamento ) { 
            id_orcamento = this.$route.params.id_orcamento;
        } else if ( this.id_orcamento ) { 
            id_orcamento = this.id_orcamento;
        }

        if ( id_orcamento ) { 

            this.$nextTick(() => { 
                this.$util.load(this, { 
                    service: 'orcamentos',
                    func: 'show', 
                    parms: {  
                        id: id_orcamento, 
                        sel_orcamento: true, 
                    },
                    loadTo: res => { 
                        this.$refs.marc.$refs.orcamento.selecionar_orcamento(res);
                    }
                });
                
            });

        }

        // Geração de Orçamento de Requisição.

        const origem = this.$route.params.origem;

        if ( origem && origem.id_solicitacao_autorizacao && origem.plano_orcamento ) {

            const plano = origem.plano_orcamento;
            const id_uo = origem.id_unidade_operacao;
            const nome  = origem.paciente 
                ? origem.paciente.st_nome 
                : ( origem.cadastro_temporario ? origem.cadastro_temporario.st_nome : "" );

            let unidade = this.$refs.marc.lista_unidades.find(und => und.id_unidade_operacao == id_uo);

            if ( unidade ) { 
                this.$refs.marc.dados.unidade_operacao = unidade;    
            }

            this.$refs.marc.$refs.orcamento.nome_paciente = nome;
            this.$refs.marc.$refs.orcamento.paciente = origem.paciente;

            if ( origem.paciente ) { 
                this.$refs.marc.$refs.orcamento.paciente.origem = { 
                    type: 'App\\azure\\solicitacaoAutorizacao', 
                    id: origem.id_solicitacao_autorizacao
                };
            }
            
            this.$refs.marc.selecionarPlano(plano);

            //

            let procedimentos = [];

            if ( origem.in_status == 3 || ( origem.plano && origem.plano.id_operadora == 1 ) ) { 
                procedimentos.push(origem.procedimento);
            }

            procedimentos = procedimentos.concat(origem.js_secundarios.filter(item => { 
                    return item.in_status == 3 || ( origem.plano && origem.plano.id_operadora == 1 );
                }).map(item => { 
                    if ( item.in_quantidade ) { 
                        item.in_qtde_default = item.in_quantidade;
                    }
                    
                    return item;
                })
            );

            if ( procedimentos.length ) { 
                this.$refs.marc.selecionarProcedimento(procedimentos);
            }
            
        } else if ( origem && ( origem.id_requisicao || origem.id_receita ) ) { 

            const plano = origem.plano ? origem.plano : origem.anamnese.atendimento_procedimento.atendimento.plano;
            const nome  = origem.anamnese.atendimento_procedimento.atendimento.paciente.st_nome;
            const id_uo = _.get(origem, 'anamnese.atendimento_procedimento.atendimento.marcacao.id_unidade_operacao', -1);
            
            let unidade = this.$refs.marc.lista_unidades.find(und => und.id_unidade_operacao == id_uo);

            if ( unidade ) { 
                this.$refs.marc.dados.unidade_operacao = unidade;    
            }

            this.$refs.marc.$refs.orcamento.nome_paciente = nome;
            this.$refs.marc.$refs.orcamento.paciente = origem.anamnese.atendimento_procedimento.atendimento.paciente;

            if ( origem.id_requisicao ) { 
                this.$refs.marc.$refs.orcamento.paciente.origem = { 
                    type: 'App\\azure\\requisicao', 
                    id: origem.id_requisicao
                };
            } else if ( origem.id_receita ) { 
                this.$refs.marc.$refs.orcamento.paciente.origem = { 
                    type: 'App\\azure\\receita', 
                    id: origem.id_receita
                };
            }
            
            this.$refs.marc.selecionarPlano(plano);

            if ( origem.medico_orc ) { 
                this.$refs.marc.selecionarMedico(origem.medico_orc);
            }

            //
            let procedimentos = [];

            if ( origem.id_requisicao ) { 
             
                procedimentos = origem.items.map(item => { 
                    if ( item.in_quantidade ) { 
                        item.item.in_qtde_default = item.in_quantidade;
                    }
                    
                    return item.item;
                });

            } else if ( origem.procedimento ) { 

                procedimentos.push({ 
                    ...origem.procedimento, 
                    in_qtde_default: 1, 
                });

            }

            if ( procedimentos.length ) { 
                this.$refs.marc.selecionarProcedimento(procedimentos);

                if ( origem.id_receita ) { 
                    setTimeout(() => { 
                        
                        this.$util.loadItem(this, { 
                            service: 'pep',
                            func: 'receita_detalhe_cobranca',
                            parms: { 
                                id_atendimento: origem.anamnese.atendimento_procedimento.id_atendimento,
                                id_receita: origem.id_receita,
                            }
                        })
                        .then(res => { 
                            if ( res && res.receita && res.receita.flat_items && res.receita.flat_items.length ) { 
                                res.receita.flat_items.forEach(element => {
                                    let consumo = { 
                                        id_medicamento: element.id_medicamento, 
                                        search: element.item.search,
                                        qtde: element.dc_dose_calc 
                                            ? Math.round(element.dc_dose_calc) 
                                            : ( element.in_quantidade ? element.in_quantidade : 1 ) 
                                    };

                                    this.$refs.marc.$refs.orcamento.incluirComponentePrimeiro(consumo);    
                                });
                            }
                        });

                    }, 1000);
                }
            }

        } else if ( origem && origem.id_marcacao ) { 

            if ( origem.id_orcamento ) { 
                this.$util.loadItem(this, { 
                    service: 'orcamentos',
                    func: 'show',
                    parms: { 
                        id: origem.id_orcamento,
                        orcamento: true, 
                    },
                })
                .then(res => { 
                    this.$refs.marc.$refs.orcamento.selecionar_orcamento(res);
                })

                return;
            }

            const plano = origem.plano;
            const id_uo = origem.id_unidade_operacao;
            const nome  = origem.paciente 
                ? origem.paciente.st_nome
                : ( origem.cadastro_temporario ? origem.cadastro_temporario.st_nome : 'Paciente' );

            let unidade = this.$refs.marc.lista_unidades.find(und => und.id_unidade_operacao == id_uo);

            if ( unidade ) { 
                this.$refs.marc.dados.unidade_operacao = unidade;    
            }

            this.$refs.marc.$refs.orcamento.nome_paciente = nome;
            this.$refs.marc.$refs.orcamento.paciente = origem.paciente
                ? origem.paciente
                : {
                    cadastro: {
                        st_email: origem.cadastro_temporario.st_email, 
                        telefones: {
                            telefone: origem.cadastro_temporario.st_telefone,
                            celular: origem.cadastro_temporario.st_celular,
                        }
                    }
                };
            
            this.$refs.marc.$refs.orcamento.paciente.origem = { 
                type: 'App\\azure\\marcacao', 
                id: origem.id_marcacao
            };
            
            this.$refs.marc.selecionarPlano(plano);

            //

            let procedimentos = [];

            this.$util.loadItem(this, { 
                service: 'marcacoes',
                func: 'show',
                parms: { 
                    id: origem.id_marcacao,
                    para_remarcacao: true, 
                }
            })
            .then(res => { 

                procedimentos.push({ 
                    id_procedimento: res.id_procedimento, 
                    st_procedimento: res.procedimento.st_procedimento, 
                    search: res.procedimento.search, 
                });

                if ( res.js_outros_procedimentos && res.js_outros_procedimentos.length ) { 
                    procedimentos = procedimentos.concat(res.js_outros_procedimentos);
                }

                console.log(procedimentos);

                if ( procedimentos.length ) { 
                    this.$refs.marc.selecionarProcedimento(procedimentos);
                }

            });

        }

    }
    
}
</script>